import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import store from './state/store';

import { Provider } from 'react-redux';


const rootElement = document.getElementById("betarades-user-ratings");
const id = rootElement.getAttribute("data-id");
const type = rootElement.getAttribute("data-type");
const title = rootElement.getAttribute("data-title");
const pageTitle = rootElement.getAttribute("data-page-title");

ReactDOM.render(
	<Provider store={store}>
		<App id={id} type={type} title={title} pageTitle={pageTitle} />
	</Provider>,
rootElement);



// WEBPACK FOOTER //
// ./src/index.js